import * as React from 'react';
import { withStyles, Theme, createStyles, WithStyles, Tabs, Tab } from '@material-ui/core';
import AccountInfo from './AccountInfo';
import ChangePassword from './ChangePassword/ChangePassword';
import strings from 'src/strings';
import AddressForm from '../Checkout/AddressForm';
import EditSubscription from '../ManageSubscription/EditSubscription';
import PaymentForm from '../Checkout/PaymentForm';
import { Elements } from 'react-stripe-elements';
import Datasource from '../Client/Datasource';

export interface SettingsProps extends WithStyles<typeof styles> {
}
interface SettingsState {
    tab: number;
}
class Settings extends React.Component<SettingsProps, SettingsState> {

    constructor(props: SettingsProps) {
        super(props);
        this.state = {
            tab: 0,
        }
    }

    public render() {
        const { tab } = this.state;
        return <>
            <Tabs value={tab} onChange={(_, value) => { this.setState({ tab: value }) }}>
                <Tab label={strings.accountInfo} />
                <Tab label={strings.manageSubscription} />
                <Tab label={strings.client_datasource} />
                <Tab label={strings.changePassword} />
                <Tab label={strings.checkout_billingAddress} />
                <Tab label={strings.checkout_paymentMethod} />
            </Tabs>
            {tab == 0 && <AccountInfo className={this.props.classes.page} />}
            {tab == 2 && <Datasource className={this.props.classes.page} />}
            {tab == 3 && <ChangePassword className={this.props.classes.page} />}
            {tab == 4 && <AddressForm className={this.props.classes.page} hideHeader={true} onNext={() => {
                //this.props.onClose()
            }} nextButtonText={strings.done} />}
            {tab == 5 && <PaymentForm className={this.props.classes.page} hideHeader={true} onNext={() => {
                //this.props.onClose()
            }} nextButtonText={strings.done} />}
            {tab == 1 && <EditSubscription className={this.props.classes.page} onLoading={(loading) => {
                //this.setState({ loading: loading })
            }} />}
        </>
    }
}
const styles = (theme: Theme) => createStyles({
    page: {
        maxWidth: 500,
        padding: theme.spacing(2)
    }
})

const SettingComp = withStyles(styles)(Settings)
export default class SettingsWrapper extends React.PureComponent {
    public render() {
        return <Elements>
            <SettingComp />
        </Elements>
    }
}


// WEBPACK FOOTER //
// ./src/components/Settings/Settings.tsx